// extracted by mini-css-extract-plugin
export default {"container":"_A-z","heading":"aB-z","text":"bB-z","info":"cB-z","link":"dB-z","fullMaxWidth":"eB-z"};